// AddDatabaseModalTemplateStep.jsx

import React from 'react';

// Components
import DictionarySection from 'components/addmodal/sections/dictionary/DictionarySection';

/**
 * AddDatabaseModalTemplateStep
 *
 * Renders the template selection and variant provisioning step.
 *
 * @param {object} dictionaryState - Dictionary provisioning state and handlers.
 *
 * @returns {ReactNode} The rendered template step.
 */
const AddDatabaseModalTemplateStep = ({ dictionaryState }) => {
    return (
        <DictionarySection
            query={dictionaryState.query}
            setQuery={dictionaryState.setQuery}
            loading={dictionaryState.loading}
            error={dictionaryState.error}
            terms={dictionaryState.terms}
            selectedTerm={dictionaryState.selectedTerm}
            selectedVariant={dictionaryState.selectedVariant}
            isVariantStep={dictionaryState.isVariantStep}
            isVariantPreviewStep={dictionaryState.isVariantPreviewStep}
            isProvisioning={dictionaryState.isProvisioning}
            provisioningVariantKey={dictionaryState.provisioningVariantKey}
            selectedFieldKeys={dictionaryState.selectedFieldKeys}
            workspaceKey={dictionaryState.workspaceKey}
            onSelectTerm={dictionaryState.handleSelectTerm}
            onSelectVariant={dictionaryState.handleSelectVariant}
            onToggleSelectedField={dictionaryState.handleToggleSelectedField}
        />
    );
};

export default AddDatabaseModalTemplateStep;